import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      if (!sessionIdMatch) {
        navigate("/login");
        return;
      }
      const sessionId = sessionIdMatch[1];

      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data.user);
        // Also save token for header-based auth fallback
        if (res.data.session_token) {
          localStorage.setItem("access_token", res.data.session_token);
        }
        window.history.replaceState({}, document.title, "/");
        navigate("/", { state: { user: res.data.user } });
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/login");
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-foreground font-light tracking-tight">Autenticando...</div>
    </div>
  );
}
